module.exports = __webpack_public_path__ + "img/h2-01.984e151b.png";